var map = {
	"./de_DE.json": 1079,
	"./en_AU.json": 1080,
	"./en_CA.json": 1081,
	"./en_GB.json": 1082,
	"./es_AR.json": 1083,
	"./es_ES.json": 1084,
	"./es_MX.json": 1085,
	"./fr_CA.json": 1086,
	"./fr_FR.json": 1087,
	"./it_IT.json": 1088,
	"./nl_NL.json": 1089,
	"./pt_BR.json": 1090,
	"./pt_PT.json": 1091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1078;